import API from "@/models/API";

export default class Gifts {
    static get = (query) =>
        API.get(
            `/suppliers/${localStorage.getItem("storeId")}/gifts${query}`
        );
}
